import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { THREE_LETTER_EU_COUNTRY_CODES } from "./THREE_LETTER_EU_COUNTRY_CODES";
export var THREE_LETTER_EUROPE_COUNTRY_CODES = _objectSpread(_objectSpread({}, THREE_LETTER_EU_COUNTRY_CODES), {}, {
  ALA: "ALA",
  ALB: "ALB",
  AND: "AND",
  ARM: "ARM",
  AZE: "AZE",
  BIH: "BIH",
  BLR: "BLR",
  CHE: "CHE",
  FRO: "FRO",
  GBR: "GBR",
  GEO: "GEO",
  GGY: "GGY",
  GIB: "GIB",
  IMN: "IMN",
  ISL: "ISL",
  JEY: "JEY",
  KAZ: "KAZ",
  LIE: "LIE",
  MCO: "MCO",
  MDA: "MDA",
  MKD: "MKD",
  MNE: "MNE",
  NOR: "NOR",
  RUS: "RUS",
  SJM: "SJM",
  SMR: "SMR",
  SRB: "SRB",
  TUR: "TUR",
  UKR: "UKR",
  VAT: "VAT",
  XKX: "XKX"
});